import React, { useState, useEffect } from "react";
import {
  withStyles,
  makeStyles,
  createStyles,
  useTheme,
} from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import {
  FormHelperText,
  Input,
  InputLabel,
  InputBase,
  Button,
} from "@material-ui/core";
import { addDays } from 'date-fns';
import Radio from '@material-ui/core/Radio';
import DatePicker from '@mui/lab/DatePicker';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from "@material-ui/core/Checkbox";
import FormControl from "@material-ui/core/FormControl";
import RadioGroup from '@material-ui/core/RadioGroup';
import grey from "@material-ui/core/colors/grey";
import Select from '@material-ui/core/Select';
import TextField from '@mui/material/TextField';
// import Grid from '@material-ui/core/Grid';
import clsx from "clsx";
import { getDefaultTabName } from "../../services/FunctionServices";
import { useDispatch } from "react-redux";
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
import CustomerName from "../CommonComponents/Customer_name";
import AssetCustomerName from "../CommonComponents/AssetCustomer_name";
import ShipName_imo from "../CommonComponents/ShipName_imo";
import ReportStatus from "../CommonComponents/ReportStatus";
import LubeReportStatus from "../CommonComponents/LubeReportStatus";
import TotReportStatus from "../CommonComponents/TotReportStatus";
import SampleStatus from "../CommonComponents/SampleStatus";
import LubeSampleStatus from "../CommonComponents/LubeSampleStatus";
import TotSampleStatus from "../CommonComponents/TotSampleStatus";
import TotSample_number from "../CommonComponents/TotsampleNamber";
import Service_type from "../CommonComponents/Service_type";
import Reporttype from "../CommonComponents/Reporttype"
import Lab_Fqt from "../CommonComponents/lab_Fqt"
import Bunkerport from "../CommonComponents/bunkerport";
import FuelOffSpec from "../CommonComponents/OffSpec";
import Fuelsupplier from "../CommonComponents/Fuelsupplier";
import Bunkeredcity from "../CommonComponents/bunkeredcity";
import Fuelgrade from "../CommonComponents/fuelgrade";
import Iso_spec from "../CommonComponents/iso_spec";
import Bargename from "../CommonComponents/bargename";
import Samplenumber from "../CommonComponents/Samplenumber"
import EquipName from "../CommonComponents/EquipName"
import EquipMake from "../CommonComponents/EquipMake"
import EquipModel from "../CommonComponents/EquipModel";
import LoBrand from "../CommonComponents/LoBrand";
import LoGrade from "../CommonComponents/LoGrade";
import Lab_Tot from "../CommonComponents/lab_Tot";
import Lab_Lube from "../CommonComponents/lab_Lube";
import Manufacturer from "../CommonComponents/Manufacturer";
import DateComponent from "../CommonComponents/DateComponent";
import FqtReportDateComponent from "../CommonComponents/FqtReportDate";
import FqtSampleDateComponent from "../CommonComponents/FqtSampledate";
import FqtBunkerDateComponent from "../CommonComponents/FqtBunkerDate";
import LubeSampleDateComponent from "../CommonComponents/LubeSampleDate";
import LubeReportDateComponent from "../CommonComponents/LubeReportDate";
import TotSampleDateComponent from "../CommonComponents/TotSampleDate";
import TotReportDateComponent from "../CommonComponents/TotReportDate";
import TotUnitDescripitionComponent from "../CommonComponents/TotUnitDescription";
import TotSubCustomerNameComponent from "../CommonComponents/TotSubCustomerName";
import Fleet from "../CommonComponents/Fleet";
import DWTRangeComponent from "../CommonComponents/DWTRange";
import ShipyardComponent from "../CommonComponents/Shipyard";
import YearBuiltComponent from "../CommonComponents/YearBuilt";
import AssetEquipmentComponent from "../CommonComponents/AssetsEqupiment";
import HelpIcon from '@material-ui/icons/Help';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import Grid from '@mui/material/Grid';
import SerialNumber from "../CommonComponents/SerialNumber";
import Location from "../CommonComponents/Location";
import Voltage from "../CommonComponents/Voltage";
import TransformerName from "../CommonComponents/TotTransformername";
import ClientContract from "../CommonComponents/ClientContract";
import { FilterObj } from '../CommonComponents/globalfilterObj';
import { getRequest, postRequest } from "../../services/ApiServices";
import { getCookie, setCookie } from "../../services/Cookies";
import Rating from '../CommonComponents/Rating';
import FuelShipType from "../CommonComponents/FuelShipType";
import LubeShipType from "../CommonComponents/LubeShipType";
const useStyles = makeStyles((theme) => ({
  justifyContentBetween: {
    justifyContent: "space-between!important",
  },
  alignItemsStretch: {
    alignItems: "stretch",
  },
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  paper: {
    padding: theme.spacing(2),
    // textAlign: "center",
    color: theme.palette.text.secondary,
  },
  gridSpacing: {
    margin: "0 !important",
    width: "100% !important",
  },
  btnFilters: {
    color: "#ff4717",
    border: "1px solid rgb(255 71 23)",
    textTransform: "capitalize",
  },
  alignment: {
    alignItems: "center",
  },
  button: {
    display: 'block',
    marginTop: theme.spacing(2),
  },
  btnStyle2: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "4px 22px",
    marginRight: "8px"
  },
  dateleft: {
    maxWidth: "45%",
    display: "inline-block",
  },
  dateright: {
    maxWidth: "45%",
    marginLeft: "5%",
    display: "inline-block",
  },
  formControl: {
    // margin: theme.spacing(1),
    minWidth: "200px",
    "& select": {
      padding: "6px"
    }
  }
}));
const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(2),
    },
  },

  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.common.white,
    border: "1px solid #ced4da",
    fontSize: 16,
    width: "auto",
    padding: "10px 12px",
    height: "0.1876em",
    // marginLeft: '2.2em',
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
    "&.Mui-disabled": {
      backgroundColor: "#eee"
    }
  },
}))(InputBase);

const BootstrapDate = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(2),
    },
  },

  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.common.white,
    border: "1px solid #ced4da",
    fontSize: 16,
    width: "100%",
    padding: "10px 12px",
    height: "0.1876em",
    // marginLeft: '2.2em',
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
    "&.Mui-disabled": {
      backgroundColor: "#eee"
    }

  },
}))(InputBase);

export default function Global_Filter() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [formObj, setFormObj] = useState(FilterObj);
  const [GlobalFilterSettingValue, setGlobalFilterSettingValue] = React.useState(localStorage.getItem('GlobalFilterSetting'));
  const [FqTdefault, setFqtdefault] = React.useState(false);
  const [Lubedefault, setLubedefault] = React.useState(false);
  const [Totdefault, setTotdefault] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState('paper');
  const [checkedHistory, setCheckedHistory] = React.useState(false);
  // const serviceTypes = getCookie("serviceTypes").split(',');

  const handleClickOpen = (scrollType) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (event) => {
    debugger
    setCheckedHistory(event.target.checked);
    //setFormObj({ ...formObj, HistoricVessel: event.target.checked })
  };
  const descriptionElementRef = React.useRef(null);
  const getDefaultTab = () => {

    const serviceTypes = getCookie("serviceTypes").split(',');
    let tabIndex = [];
    serviceTypes.forEach((serviceType) => {
      if (serviceType == "TOT") {
        // tabIndex.push(2);
        setTotdefault(true);
      }
      if ((serviceType == "Lube Analysis" || serviceType == "OCM" || serviceType == "SDA" || serviceType == "Grease" || serviceType == "Compatibility" || serviceType == "Ferrography")) {
        //tabIndex.push(1);
        setLubedefault(true)
      }
      if ((serviceType == "FQT" || serviceType == "FSC" || serviceType == "FCA" || serviceType == "GCMS" || serviceType == "BQS")) {
        //tabIndex.push(0);
        setFqtdefault(true)
      }

    });

  }
  const Reportdate = (value) => {
    //
    let startdate = [];
    let enddate = [];
    value.forEach((val, i) => {
      //
      startdate.push(val.startDate);
      enddate.push(val.endDate);
    })
    setFormObj({ ...formObj, Fqtreportstartdate: startdate, Fqtreportenddate: enddate })
  }
  const sampledate = (value) => {
    //
    let startdate = [];
    let enddate = [];
    value.forEach((val, i) => {
      //
      startdate.push(val.startDate);
      enddate.push(val.endDate);
    })
    setFormObj({ ...formObj, Fqtsamplestartdate: startdate, Fqtsampleenddate: enddate })

  }
  const bunkerdate = (value) => {
    let startdate = [];
    let enddate = [];
    value.forEach((val, i) => {
      //
      startdate.push(val.startDate);
      enddate.push(val.endDate);
    })
    setFormObj({ ...formObj, Fqtbunkerstartdate: startdate, Fqtbunkerenddate: enddate })

  }
  const lubereportdate = (value) => {
    let startdate = [];
    let enddate = [];
    value.forEach((val, i) => {
      //
      startdate.push(val.startDate);
      enddate.push(val.endDate);
    })
    setFormObj({ ...formObj, lubereportstartdate: startdate, lubereportenddate: enddate })

  }
  const lubesampledate = (value) => {
    let startdate = [];
    let enddate = [];
    value.forEach((val, i) => {
      //
      startdate.push(val.startDate);
      enddate.push(val.endDate);
    })
    setFormObj({ ...formObj, lubesamplestartdate: startdate, lubesampleenddate: enddate })

  }
  const Totsampletdate = (value) => {
    let startdate = [];
    let enddate = [];
    value.forEach((val, i) => {
      //
      startdate.push(val.startDate);
      enddate.push(val.endDate);
    })
    setFormObj({ ...formObj, Totsamplestartdate: startdate, Totsampleenddate: enddate })

  }
  const Totreportdate = (value) => {
    let startdate = [];
    let enddate = [];
    value.forEach((val, i) => {
      //
      startdate.push(val.startDate);
      enddate.push(val.endDate);
    })
    setFormObj({ ...formObj, Totreportstartdate: startdate, Totreportenddate: enddate })

  }

  const CustomerSelected = (newValue) => {
    //
    if (newValue) {
      setFormObj({ ...formObj, customerNameKey: newValue })
    } else {
      setFormObj({ ...formObj, customerNameKey: [{ id: "", name: "" }] });
    }
  }

  const ShipNameImoSelected = (event,newValue) => {
    //
    // let VesselKeyarr = [];
    // newValue.forEach((val, i) => {
    //   VesselKeyarr.push(val.vesselKey)
    // })
    // let vesselKey = VesselKeyarr.toString();
    // setFormObj({ ...formObj, shipNameImokey: vesselKey })
    //SetShipNameImoSelecteddata(vesselKey)
    if (newValue) {
      setFormObj({ ...formObj, shipNameImokey: newValue })
    } else {
      setFormObj({ ...formObj, shipNameImokey: [{ id: "", name: "" }] });
    }
  }
  const Servicetypeselected = (newValue) => {

    setFormObj({ ...formObj, servicetype: newValue })
  }
  const ReportStatusselected = (newValue) => {

    setFormObj({ ...formObj, Fqtreportstatus: newValue })

  }
  const LubeReportStatusselected = (newValue) => {

    setFormObj({ ...formObj, lubereportstatus: newValue })

  }
  const TotReportStatusselected = (newValue) => {
    setFormObj({ ...formObj, Totreportstatus: newValue })
  }
  const TotUnitDescripitionselected = (newValue) => {
    setFormObj({ ...formObj, TotUnitDescription: newValue })
  }
  const TotSubCustomerNameselected = (newValue) => {
    setFormObj({ ...formObj, TotSubCustomerName: newValue })
  }
  const Fqtsamplestatusselected = (newValue) => {

    setFormObj({ ...formObj, Fqtsamplestatus: newValue })
  }
  const FqtBunkerport = (newValue) => {

    setFormObj({ ...formObj, Fqtbunkerport: newValue })
  }
  const FqtBunkerCity = (newValue) => {
    //
    setFormObj({ ...formObj, Fqtbunkercity: newValue })

  }
  const FqtBargeName = (newValue) => {
    //
    setFormObj({ ...formObj, Fqtbargename: newValue })
  }
  const Fqtsamplenumber = (newValue) => {

    setFormObj({ ...formObj, Fqtsamplenumber: newValue })
  }
  const FqtFuelGrade = (newValue) => {
    setFormObj({ ...formObj, Fqtfuelgrade: newValue })
  }
  const FqtLab = (newValue) => {
    setFormObj({ ...formObj, Fqtlab: newValue })
  }
  const Fuelsupplierchange = (newValue) => {
    setFormObj({ ...formObj, FqtSupplier: newValue })
  }
  const LubeLab = (newValue) => {
    setFormObj({ ...formObj, lubelab: newValue })
  }
  const TotLab = (newValue) => {
    setFormObj({ ...formObj, Totlab: newValue })
  }
  const lubesamplestatus = (newValue) => {
    setFormObj({ ...formObj, lubesamplestatus: newValue })
  }
  const lubeequipname = (newValue) => {
    setFormObj({ ...formObj, lubeequipname: newValue })
  }
  const lubeequipmake = (newValue) => {
    setFormObj({ ...formObj, lubeequipmake: newValue })
  }
  const lubeequipmodal = (newValue) => {
    setFormObj({ ...formObj, lubeequipmodel: newValue })
  }
  const lubelobrand = (newValue) => {
    setFormObj({ ...formObj, lobrand: newValue })
  }
  const lubelogrede = (newValue) => {
    setFormObj({ ...formObj, lograde: newValue })
  }
  const Totsamplestatus = (newValue) => {

    setFormObj({ ...formObj, Totsamplestatus: newValue })
  }
  const Totserialnumber = (newValue) => {

    setFormObj({ ...formObj, Totserialnumber: newValue })
  }
  const Totlocation = (newValue) => {

    setFormObj({ ...formObj, Totlocation: newValue })
  }
  const Totclientcontract = (newValue) => {

    setFormObj({ ...formObj, Totclientcontract: newValue })
  }
  const Totmanufacture = (newValue) => {
    setFormObj({ ...formObj, Totmanufacture: newValue })
  }
  const Totvoltage = (newValue) => {

    setFormObj({ ...formObj, Totvoltage: newValue })
  }
  const Totsamplenumber = (newValue) => {

    setFormObj({ ...formObj, Totsamplenumber: newValue })
  }
  const TotTransformerName = (newValue) => {
    setFormObj({ ...formObj, TotTransformerName: newValue })
  }
  const TotRating = (newValue) => {
    setFormObj({ ...formObj, TotRating: newValue })
  }
  const Fuelshiptypechange = (newValue) => {
    setFormObj({ ...formObj, FqtShipType: newValue })
  }
  const FuelOffSpecchange = (newValue) => {

    setFormObj({ ...formObj, FqtOffSpec: newValue })
  }
  const Lubeshiptypechange = (newValue) => {
    setFormObj({ ...formObj, lubeShipType: newValue })
  }
  const AssetsCustomername = (newValue) => {
    setFormObj({ ...formObj, AssetscustomerNameKey: newValue })
  }
  const AssetEquipment = (newValue) => {
    setFormObj({ ...formObj, Assetsequipment: newValue })
  }
  const applyFilter = () => {

    const myJSONData = JSON.stringify(formObj);
    const Data = {
      Data: myJSONData,
    }
    //setCookie(formObj);
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `CommonComponent/GlobalFilterTotalData`;
    postRequest(url, Data)
      .then((res) => {
        if (res.status == 200) {
          ToastSuccess("Updated Successfully");
          // let changedvalue = res.data;
          // let Obj = [];
          // changedvalue.map((val, i) => {
          //   //
          //   let jsontoObj = (val.data);
          //   Obj = JSON.parse(jsontoObj);
          // })
          //setNewValue(Obj);
          //
          localStorage.setItem("GlobalFilterSetting", res.data[0].data);
        } else {
          ToastSuccess("Updated Unsucessfull");
        }

      })
      .catch((error) => {

      });
  }
  React.useEffect(() => {

    let GlobalFilterSetting = localStorage.getItem('GlobalFilterSetting');
    if (GlobalFilterSetting !== "" && GlobalFilterSetting !== undefined && GlobalFilterSetting !== "null") {
      let Obj = JSON.parse(GlobalFilterSetting);
      setFormObj(Obj);

    }
    getDefaultTab();
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  return (
    <div className={classes.root}>
      <div className="mar25 gfdate gffilter">
        {/* <FromDateToDate/> */}
        <div className="breadcurmbg mb25">
          <span> Filters</span>
        </div>
        <Box component="div" className="pos_relative">
          <Box component="div" className="help_blk2">
            <Button onClick={handleClickOpen('paper')}> <HelpIcon style={{ color: "#ff4717" }} /></Button>

            <Dialog
              open={open}
              scroll={scroll}
              aria-labelledby="scroll-dialog-title"
              aria-describedby="scroll-dialog-description"
            >
              <DialogTitle id="scroll-dialog-title">Tips & Tricks</DialogTitle>
              <DialogContent dividers={scroll === 'paper'}>
                <DialogContentText
                  id="scroll-dialog-description"
                  ref={descriptionElementRef}
                  tabIndex={-1}
                >

                  <p className="subtitle">Filters panel help section</p><br />
                  <ul>
                    <li>Type some thing in auto select box to see options.</li>
                    <li>For muliple selection hold control + click.</li>
                    <li>X button clear all results.</li>
                    <li>Click on close button in individual selection to remove it.</li>
                    <li>Click on Apply Filters to apply selected filters.</li>
                    <li>Click on reset to put the filters back to selection that was made in global filter page.</li>
                  </ul>

                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose}>Close</Button>
              </DialogActions>
            </Dialog>
          </Box>
        </Box>
        <Box
          component="div"
          px={1}
          pt={1.2}
          pb={0}
          display="flex"
          className={clsx(
            classes.justifyContentBetween,
            classes.alignItemsStretch
          )}
        >
          <Box component="h3" m={0} pl={1} className="blcopy"   >
            Filters
          </Box>
          <Grid item xs={12} sm={6} style={{ marginLeft: "100px" }}>
            <Box display="flex" justifyContent="flex-end">
              {/* <FormControlLabel
                                control={<Switch checked={checked} onChange={handleCheckedChange} />}
                                label="Show Filters"
                            /> */}
              <FormControlLabel label="Historic Vessels"
                control={
                  <Checkbox checked={checkedHistory} onChange={handleChange} />
                }
              />
            </Box>
          </Grid>
        </Box>
        <Box component="div" px={1} py={1} className="globalDiv"  >

          <Grid container spacing={4}>
            <Grid item xs={12} sm={6} md={3}>
              <CustomerName screen={"GlobalFilter"} onChange={CustomerSelected} updateParent={setFormObj} type="customer"></CustomerName>
            </Grid>
            {FqTdefault == true || Lubedefault == true ?
              <Grid item xs={12} sm={6} md={3}>
                <ShipName_imo screen={"GlobalFilter"} onChange={ShipNameImoSelected} updateParent={setFormObj} HistoricVessel={checkedHistory} />
              </Grid> : ''}
            <Grid item xs={3} sm={6} md={3} >
              <Service_type screen={"GlobalFilter"} onChange={Servicetypeselected} />
            </Grid>

          </Grid>


        </Box>
        {FqTdefault == true ?
          <>
            <Box
              component="div"
              px={1}
              pt={0}
              pb={0}
              display="flex"
              className={clsx(
                classes.justifyContentBetween,
                classes.alignItemsStretch
              )}
            >
              <Box component="h3" m={0} pl={1} className="blcopy pt20"   >
                FQT Filters
              </Box>

            </Box>
            <Box component="div" px={1} py={1} className="padbtm0" >

              <Grid container spacing={4} className="mb35">
                <Grid item xs={12} sm={6} md={3}>
                  <SampleStatus onChange={Fqtsamplestatusselected} />
                </Grid>
                <Grid item xs={12} sm={6} md={3} >
                  <Bunkerport screen={"GlobalFilter"} onChange={FqtBunkerport} />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Bunkeredcity onChange={FqtBunkerCity} />
                </Grid>
                <Grid item xs={12} sm={6} md={3} className="widthcc1">
                  <Bargename screen={"GlobalFilter"} onChange={FqtBargeName} />
                </Grid>
              </Grid>



              <Grid container spacing={4} className="mb35">
                <Grid item xs={12} sm={6} md={3}>
                  <Lab_Fqt screen={"GlobalFilter"} onChange={FqtLab} />
                </Grid>
                <Grid item xs={12} sm={6} md={3} >
                  <Samplenumber screen={"GlobalFilter"} onChange={Fqtsamplenumber} />
                </Grid>
                <Grid item xs={12} sm={6} md={3} >
                  <ReportStatus onChange={ReportStatusselected}></ReportStatus>
                </Grid>

                <Grid item xs={12} sm={6} md={3} className="widthcc1">
                  <Fuelgrade screen={"GlobalFilter"} onChange={FqtFuelGrade} />
                </Grid>

              </Grid>



              <Grid container spacing={4} className="mb35">
                <Grid item xs={12} sm={6} md={3}>
                  <Fuelsupplier screen={"GlobalFilter"} onChange={Fuelsupplierchange} />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <FuelShipType screen={"GlobalFilter"} onChange={Fuelshiptypechange} />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <FuelOffSpec screen={"GlobalFilter"} onChange={FuelOffSpecchange} />
                </Grid>
                <Grid item xs={12} sm={6} md={3} className="doubledate" >
                  <Box component="label" >
                    Bunker Date (From - To)
                  </Box>
                  {/* <DateComponent onChange={bunkerdate} value={BunkerDate} /> */}
                  <FqtBunkerDateComponent onChange={bunkerdate} />
                </Grid>
              </Grid>
              <Grid container spacing={4} className="mb35">
                <Grid item xs={12} sm={6} md={3} className="doubledate">
                  <Box component="label" >
                    Reported Date (From - To)
                  </Box>
                  <FqtReportDateComponent onChange={Reportdate} />
                </Grid>
                <Grid item xs={12} sm={6} md={3} className="doubledate" >
                  <Box component="label" >
                    Sampled Date (From - To)
                  </Box>
                  <FqtSampleDateComponent onChange={sampledate} />
                </Grid>
              </Grid>
            </Box>
          </> : ""}
        {Lubedefault == true ?
          <>
            <Box
              component="div"
              px={1}
              pt={0}
              pb={0}
              display="flex"
              className={clsx(
                classes.justifyContentBetween,
                classes.alignItemsStretch
              )}
            >
              <Box component="h3" m={0} pl={1} className="blcopy pt20"   >
                Lube Filters
              </Box>

            </Box>
            <Box component="div" px={1} py={1} className="padbtm0" >

              <Grid container spacing={4} className="mb35">
                <Grid item xs={12} sm={6} md={3}>
                  <LubeSampleStatus onChange={lubesamplestatus} />
                </Grid>
                {/* <Grid item xs={12} sm={6} md={3}>
                      <Lab_Fqt />
                    </Grid> */}
                <Grid item xs={12} sm={6} md={3}>
                  <EquipName screen={"GlobalFilter"} onChange={lubeequipname} />
                </Grid>
                <Grid item xs={12} sm={6} md={3} className="widthcc1">
                  <EquipMake screen={"GlobalFilter"} onChange={lubeequipmake} />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <EquipModel screen={"GlobalFilter"} onChange={lubeequipmodal} />
                </Grid>

              </Grid>

              <Grid container spacing={4} className="mb35">
                <Grid item xs={12} sm={6} md={3}>
                  <Lab_Lube screen={"GlobalFilter"} onChange={LubeLab} />
                </Grid>
                <Grid item xs={12} sm={6} md={3} className="widthcc1" >
                  <LubeReportStatus onChange={LubeReportStatusselected} />
                </Grid>
                <Grid item xs={12} sm={6} md={3} >
                  <LoBrand screen={"GlobalFilter"} onChange={lubelobrand} />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <LoGrade screen={"GlobalFilter"} onChange={lubelogrede} />
                </Grid>



              </Grid>

              <Grid container spacing={4} className="mb35">
                <Grid item xs={12} sm={6} md={3}>
                  <LubeShipType screen={"GlobalFilter"} onChange={Lubeshiptypechange} />
                </Grid>

                <Grid item xs={12} sm={6} md={3} className="doubledate">
                  <Box component="label" >
                    Reported Date (From - To)
                  </Box>
                  {/* <DateComponent onChange={lubereportdate} value={LubeReportDate} /> */}
                  <LubeReportDateComponent onChange={lubereportdate} />

                </Grid>
                <Grid item xs={12} sm={6} md={3} className="doubledate">
                  <Box component="label" >
                    Sampled Date (From - To)
                  </Box>
                  {/* <DateComponent onChange={lubesampledate} value={LubeSampleDate} /> */}
                  <LubeSampleDateComponent onChange={lubesampledate} />

                </Grid>



              </Grid>


            </Box>
          </> : ""}
        {Totdefault == true ?
          <div>
            <Box
              component="div"
              px={1}
              pt={0}
              pb={0}
              display="flex"
              className={clsx(
                classes.justifyContentBetween,
                classes.alignItemsStretch
              )}
            >
              <Box component="h3" m={0} pl={1} className="blcopy"   >
                VPS Power Filters
              </Box>

            </Box>
            <Box component="div" px={1} py={1} className="padbtm0" >

              <Grid container spacing={4} className="mb35">
                <Grid item xs={12} sm={6} md={3}>
                  <TotSampleStatus onChange={Totsamplestatus} type='Totsamplestatus' />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Lab_Tot screen={"GlobalFilter"} onChange={TotLab} />
                </Grid>
                <Grid item xs={3} sm={6} md={3} >
                  <SerialNumber screen={"GlobalFilter"} onChange={Totserialnumber} />
                </Grid>
                <Grid item xs={12} sm={6} md={3} className="widthcc1">
                  <Location screen={"GlobalFilter"} onChange={Totlocation} />
                </Grid>
              </Grid>

              <Grid container spacing={4} className="mb35">
                <Grid item xs={3} sm={6} md={3}>
                  <ClientContract onChange={Totclientcontract} />
                </Grid>
                <Grid item xs={12} sm={6} md={3} >
                  <Manufacturer screen={"GlobalFilter"} onChange={Totmanufacture} />
                </Grid>
                <Grid item xs={3} sm={6} md={3} >
                  <Voltage screen={"GlobalFilter"} onChange={Totvoltage} />
                </Grid>
                <Grid item xs={12} sm={6} md={3} className="widthcc1">
                  <TotSample_number screen={"GlobalFilter"} onChange={Totsamplenumber} />
                </Grid>

              </Grid>

              <Grid container spacing={4} className="mb35">



                <Grid item xs={12} sm={6} md={3} className="widthcc1">
                  <TransformerName screen={"GlobalFilter"} onChange={TotTransformerName} />
                </Grid>
                <Grid item xs={12} sm={6} md={3} className="widthcc1">
                  <Rating screen={"GlobalFilter"} onChange={TotRating} />
                </Grid>
                <Grid item xs={12} sm={6} md={3} className="widthcc1" >
                  <TotReportStatus onChange={TotReportStatusselected} />
                </Grid>
                <Grid item xs={12} sm={6} md={3} className="widthcc1" >
                  <TotUnitDescripitionComponent screen={"GlobalFilter"} onChange={TotUnitDescripitionselected} />
                </Grid>

              </Grid>
              <Grid container spacing={4} className="mb35">
                <Grid item xs={12} sm={6} md={3} className="widthcc1" >
                  <TotSubCustomerNameComponent screen={"GlobalFilter"} onChange={TotSubCustomerNameselected} />
                </Grid>
                <Grid item xs={12} sm={6} md={3} className="doubledate">
                  <Box component="label">
                    Reported Date (From -  To)
                  </Box>
                  {/* <DateComponent onChange={Totreportdate} value={TotBunkerDate} /> */}
                  <TotReportDateComponent onChange={Totreportdate} />

                </Grid>
                <Grid item xs={12} sm={6} md={3} className="doubledate">
                  <Box component="label">
                    Sampled Date (From  - To)
                  </Box>
                  {/* <DateComponent onChange={Totsampletdate} value={TotSampleDate} />*/}
                  <TotSampleDateComponent onChange={Totsampletdate} />

                </Grid>
              </Grid>



            </Box>
          </div>
          : ""}

        {/* <Box
              component="div"
              px={1}
              pt={0}
              pb={0}
              display="flex"
              className={clsx(
                classes.justifyContentBetween,
                classes.alignItemsStretch
              )}
            >
              <Box component="h3" m={0} pl={1} className="blcopy" >
                Assets
              </Box>

            </Box>
            <Box component="div" px={1} py={1} className="padbtm0" >
              <Grid container spacing={4} className="mb35">
                <Grid item xs={12} sm={6} md={3}>
                  <AssetCustomerName onChange={AssetsCustomername} type="asset"></AssetCustomerName>
                </Grid>
                <Grid item xs={12} sm={6} md={3} >
                  <Fleet />
                </Grid>
                <Grid item xs={12} sm={6} md={3} >
                  <DWTRangeComponent />
                </Grid>
                <Grid item xs={12} sm={6} md={3} className="widthcc1">
                  <ShipyardComponent />
                </Grid>
              </Grid>

              <Grid container spacing={2} className="mb35">
                <Grid item xs={12} sm={6} md={3}>
                  <YearBuiltComponent />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <AssetEquipmentComponent onChange={AssetEquipment} />
                </Grid>
              </Grid>

              </Box> */}
        <Box component="div" className="mb35 padb15" display="flex" py={1} justifyContent="left" >
          <Button variant="outlined" className={classes.btnStyle2} onClick={applyFilter}>
            Save
          </Button>
          <Button variant="outlined" className={classes.btnStyle2}>
            Cancel
          </Button>
        </Box>

      </div>

    </div>
  );
}
